export default __webpack_public_path__ + "static/media/MoonWaspHive.5e4bdcd3.svg";